import { createFileRoute, redirect } from "@tanstack/react-router";

/** Page pleine remplacée par le volet dossier — l'image PNR s'ouvre depuis l'onglet Réservation. */
export const Route = createFileRoute("/_authed/_dashboard/claims/$claimId/pnr-display")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/claims",
      search: { claimId: params.claimId, claimTab: "passengers" },
    });
  },
});
